import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SignalrEvent } from '@wdx/shared/utils';
import { mergeMapHubToAction, signalrConnected } from 'ngrx-signalr-core';
import { catchError, map, merge, of, switchMap } from 'rxjs';
import * as importEntitiesActions from './import-entities.actions';
import { ImportTypesApiService } from '@wdx/clmi/clmi-swagger-gen/api-services';

@Injectable()
export class ImportEntitiesEffects {
    private actions$ = inject(Actions);
    private importTypesService = inject(ImportTypesApiService);

    getImportEntities$ = createEffect(() =>
        this.actions$.pipe(
            ofType(importEntitiesActions.getImportEntities),
            switchMap(() =>
                this.importTypesService.get().pipe(
                    map((imports) =>
                        importEntitiesActions.getImportEntitiesSuccess({
                            imports,
                        }),
                    ),
                    catchError((error) =>
                        of(
                            importEntitiesActions.getImportEntitiesFailure({
                                error,
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    listenToEvents$ = createEffect(() =>
        this.actions$.pipe(
            ofType(signalrConnected),
            mergeMapHubToAction(({ hub }) =>
                merge(
                    // TODO(sentry): Could not automatically migrate - see https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub
                    hub
                        .on(SignalrEvent.ImportCompleted)
                        .pipe(
                            map(() => importEntitiesActions.importCompleted()),
                        ),
                ),
            ),
        ),
    );
}
